// Interfaces
import { DataRecord } from "@/Layouts/components/InputComponents/types";

const COMPENSATION_PAIRS = {
	gross: [
		{
			type: "Dollar",
			min: -1000000000,
			max: 1000000000,
			decimalsEditable: true,
			decimals: 2,
		},
		{
			type: "Unit",
			min: -1000000000,
			max: 1000000000,
			decimalsEditable: true,
			decimals: 2,
		},
	],
	tier_gross: [
		{
			type: "Percent",
			min: -100,
			max: 100,
			decimalsEditable: true,
			decimals: 2,
		},
		{
			type: "Dollar Per Unit",
			min: -1000000000,
			max: 1000000000,
			decimalsEditable: true,
			decimals: 2,
		},
	],
	tier_rate: [
		{
			type: "Duration",
			min: 0,
			max: 744,
			decimals: 2,
			decimalsEditable: true,
		},
		{
			type: "Dollar",
			min: -1000000000,
			max: 1000000000,
			decimalsEditable: true,
			decimals: 2,
		},
	],
	rate: [
		{
			type: "Dollar",
			min: -1000000000,
			max: 1000000000,
			decimalsEditable: true,
			decimals: 2,
		},
		{
			type: "Percent",
			min: -100,
			max: 100,
			decimalsEditable: true,
			decimals: 2,
		},
	],
};
const PERCENT_TYPES = ["PERCENT", "PERCENT PER UNIT"];
const MATCH_WITH_TIERS = ["gross", "rate"];

const getInputData = (main = "", secondary = ""): DataRecord[] => {
	if (!main || (main === "tier" && !secondary)) {
		return [];
	}
	if (main === "tier") {
		return COMPENSATION_PAIRS?.[`${main}_${secondary}` as keyof object] || [];
	}
	return COMPENSATION_PAIRS?.[main as keyof object] || [];
};

const getAlternativeInput = (columns: { field: string }[] = []) => {
	const inputs = columns.map((col) => col.field);
	const isCombined = inputs.some((input) => MATCH_WITH_TIERS.includes(input));

	if (!isCombined) {
		return "default";
	}

	if (inputs.includes("rate")) {
		return "rate";
	}
	return "gross";
};

const getOppositeInput = (field: string, inputAlternative: string) => {
	if (!field || !inputAlternative) {
		return "";
	}
	if (field !== "tier") {
		return "tier";
	}
	return inputAlternative;
};

const isTierAsInput = (inputAlternative: string) => ["gross", "rate"].includes(inputAlternative);

const getInputsVariants = ({
	field,
	inputAlternative,
	inputTypeVariant = 0,
}: {
	field: string;
	inputAlternative: string;
	inputTypeVariant: number;
}) => {
	let alternative;

	const inputTier: DataRecord[] = COMPENSATION_PAIRS?.[`tier_${inputAlternative}` as keyof object] || [];
	const tier = inputTier[inputTypeVariant]?.type || "Unit";

	if (field === "tier") {
		const oppositeInput: DataRecord[] = COMPENSATION_PAIRS?.[inputAlternative as keyof object] || [];
		alternative = oppositeInput[inputTypeVariant]?.type || "Unit";
	} else {
		const oppositeInput: DataRecord[] = COMPENSATION_PAIRS?.[field as keyof object] || [];
		alternative = oppositeInput[inputTypeVariant]?.type || "Unit";
	}

	return { tier, [inputAlternative]: alternative };
};

const isPercentInput = (input = "") => PERCENT_TYPES.includes(String(input)?.toUpperCase());

const convertValueWithInput = (value = 0, input = ""): number => {
	if (!value || !input) {
		return 0;
	}
	return isPercentInput(input) ? value / 100 : value;
};

const getInputsToColumnsAddons = (inputs: { [key: string]: string }) => {
	return Object.keys(inputs).map((key) => ({
		field: key,
		input: inputs[key],
	}));
};

export {
	convertValueWithInput,
	getAlternativeInput,
	getInputsToColumnsAddons,
	getInputData,
	getInputsVariants,
	getOppositeInput,
	isTierAsInput,
};
